import { withInstall } from '@hd-front-end/utils'
import Input from './src/input.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElInput: SFCWithInstall<typeof Input> = withInstall(Input)
export default ElInput

export * from './src/input'
export type { InputInstance } from './src/instance'
